export default "__VITE_ASSET__DSF58$pL__"